module.exports = __webpack_public_path__ + "img/Icon-PreciseAPC.84753f29.png";